import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=82394a30&scoped=true"
import script from "./_article.vue?vue&type=script&lang=js"
export * from "./_article.vue?vue&type=script&lang=js"
import style0 from "./_article.vue?vue&type=style&index=0&id=82394a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82394a30",
  null
  
)

export default component.exports